<template lang="pug">
  #form
    v-layout(row justify-center)
      v-dialog(v-model="dialog" persistent max-width="850")
        v-card.py-5
            p.headline.text-xs-center ¿Estás seguro de que quieres borrar este folio?
            v-spacer.mt-4
            v-layout.px-5
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.bold(color="gray darken-3" flat @click.native="dialog = false") CANCELAR
              v-flex.px-5(d-flex xs6 justify-center)
                v-btn.bold(color="gray darken-3" flat @click.native="deleteReport") ELIMINAR FOLIO
    Header
    v-container(fluid)
      v-layout.all(row wrap)
        v-flex(xs12 sm2)
          v-layout(column)
            Side
        v-flex(xs10)
          v-layout(row wrap)
            v-flex.postal(xs12 sm12 md6 lg6)
              v-layout(row wrap)
                v-flex#top(xs6)
                  h1.form-title.pink-text Postal Asesoría
                v-flex(xs6 v-if="user.role === 'admin'")
                  v-layout(row wrap)
                    v-flex(xs4)
                      p.text-xs-center Folio Privado
                    v-flex(xs1)
                      v-switch(color="#462979" v-model="public")
                    v-flex(xs4)
                      p.text-xs-center Folio Público
              v-layout(column)
                Postal
              v-layout(column v-if="showVictim" v-for="(victim, index) in victims" :key="index")
                VictimPostal(v-bind:victimData="victim")
            v-flex.container.postal-form(xs12 sm12 md5 lg5)
              v-layout(column)
                Attention
              v-layout(column)
                Synthesis
              v-layout(column v-if="showVictim" v-for="(victim, index) in victims" :key="index")
                v-layout.container(row wrap)
                  v-flex#top(xs6)
                    h1.form-title2.pink-text Datos de la víctima
                Victim(v-bind:victimData="victim")
              v-layout.add-victim(row wrap justify-space-between v-if="showVictim")
                v-flex.btn-h(xs6)
                  v-btn(outline fab color="#4a4a4a" v-on:click="addVictim")
                    v-icon add
                  p Agregar víctima

          v-divider.form.my-4
          v-layout(row wrap)
            v-flex(xs12)
              Petitioner
          v-layout(row wrap)
            v-flex(xs12)
              Reason
          v-divider.form.my-4
          v-layout(row wrap)
            v-flex(xs12)
              Location
          v-divider.form.my-4
          v-layout(v-if="isEditing" row wrap)
            v-flex(xs12)
              Updates
          v-divider.form.my-4(v-if="isEditing")
          v-layout(v-if="isEditing" row wrap)
            v-flex(xs12)
              Edit
          v-layout(row wrap)
            v-flex(v-if="isEditing" xs6 justify-start)
              v-btn.dark-btn.bold(v-if="userPermissions.deleteReports" v-on:click="openDialog") Eliminar este folio
            v-flex(xs6 justify-end)
              v-btn.dark-btn.bold(
                to="/"
              ) Cancelar
              v-btn.dark-btn.bold(v-if="!isEditing", v-on:click="createReport") Guardar
              v-btn.dark-btn.bold(v-if="isEditing", v-on:click="updateReport") Guardar

</template>

<script>
import * as html2canvas from "html2canvas";
import * as _ from "lodash";
import Header from "@/components/Header.vue";
import Side from "@/components/Side.vue";
import Attention from "@/components/AdvisoryForm/Attention.vue";
import Synthesis from "@/components/AdvisoryForm/Synthesis.vue";
import Postal from "@/components/Postal/Postal.vue";
import Victim from "@/components/VictimForm/VictimForm.vue";
import VictimPostal from "@/components/Postal/VictimPostal.vue";
import Petitioner from "@/components/AdvisoryForm/Petitioner.vue";
import Reason from "@/components/AdvisoryForm/Reason.vue";
import Location from "@/components/Location.vue";
import Updates from "@/components/Updates.vue";
import Edit from "@/components/Edit.vue";

export default {
  name: "Form",
  props: {},
  components: {
    Header,
    Side,
    Attention,
    Synthesis,
    Postal,
    Victim,
    VictimPostal,
    Petitioner,
    Reason,
    Location,
    Updates,
    Edit
  },
  data() {
    return {
      dialog: false,
      user: this.$store.state.user,
      wrongAge: false
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    record() {
      return this.$store.getters.record;
    },
    isEditing() {
      let edit = this.$store.state.editing;
      return edit;
    },
    showVictim() {
      return this.$store.state.showVictim;
    },
    victims() {
      const selectedVictims = _.orderBy(
        this.$store.state.victims,
        ["victimFolio"],
        ["asc"]
      );
      return selectedVictims;
    },
    public: {
      get() {
        return this.$store.state.record.public;
      },
      set(value) {
        this.$store.commit("updatePublic", value);
      }
    }
  },
  methods: {
    async createReport() {
      this.$store.commit("setIsLoadingState", true);
      this.$store.commit(
        "updateVictimsAdvisory",
        this.showVictim ? this.victims : []
      );

      try {
        let createdReport = await this.$store.dispatch("createReport");
        this.record._id = createdReport.data.result["_id"];
        this.record.folio = createdReport.data.folio;
        //Assign folio to victims
        if (createdReport.data.result.victims.length > 0) {
          this.$store.state.victims.forEach(rv => {
            rv.visibleFolio = "C" + createdReport.data.folio + "V" + rv.victimFolio;
          });
        }
        // Create Postals according to images URL
        await this.createPostals(createdReport.data, "createReport");
        // UpdateCsv request
        this.updateCsv();
        // Reset form fields and return to reports list
        this.$store.commit("resetRecord");
        this.$store.commit("resetVictim");
        this.$store.commit("resetVictimImages");
        this.$store.commit("updateAttentionRelation", false);
        this.$router.replace("/");
        this.$store.commit("setIsLoadingState", false);
      } catch (error) {
        this.$store.commit("SET_CREATEREPORT_FAILURE", {
          pending: false,
          statusCode: error.status
        });
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: error.response.data.message
        });
        if (error.status == 403) {
          this.$router.replace("/login");
        }
        this.$store.commit("setIsLoadingState", false);
      }
    },
    async updateReport() {
      if (this.record._id === "" || typeof this.record._id === "undefined") {
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: "Hubo un error al buscar el reporte, por favor intenta de nuevo"
        });
        this.$router.replace("/");
      } else {
        this.$store.commit("setIsLoadingState", true);
        this.$store.commit(
          "updateVictimsAdvisory",
          this.showVictim ? this.victims : []
        );
        try {
          let uploadedReport = await this.$store.dispatch("updateReport");
          // Create Postals according to images URL
          await this.createPostals(uploadedReport.data, "updateReport");
          // UpdateCsv request
          this.updateCsv();
          // Reset form fields and return to reports list
          this.$store.commit("resetRecord");
          this.$store.commit("resetVictim");
          this.$store.commit("resetVictimImages");
          this.$store.commit("updateAttentionRelation", false);
          this.$router.replace("/");
          this.$store.commit("setIsLoadingState", false);
        } catch (error) {
          console.log(error);
          this.$store.commit("SET_UPDATEREPORT_FAILURE", {
            pending: false,
            statusCode: error.status
          });
          this.$notify({
            group: "foo",
            type: "error",
            title: "ERROR",
            text: error.response.data.message
          });

          if (error.status == 403) {
            this.$router.replace("/login");
          }
          this.$store.commit("setIsLoadingState", false);
        }
      }
    },
    deleteReport() {
      this.dialog = false;
      this.$store.commit("setIsLoadingState", true);
      this.$store
        .dispatch("deleteReport")
        .then(response => {
          if (response.status == 200) {
            this.$store.commit("SET_DELETEREPORT_SUCCESS", {
              pending: false,
              statusCode: response.status,
              data: response.data
            });
            this.$notify({
              group: "foo",
              type: "success",
              title: "ÉXITO",
              text: response.data.message
            });
            this.$store.commit("resetRecord");
            this.$store.commit("resetVictim");
            this.$router.replace("/");
            this.$store.commit("setIsLoadingState", false);

            // UpdateCsv request
            this.updateCsv();
          } else if (response.status == 403) {
            this.$router.replace("/login");
            this.$store.commit("setIsLoadingState", false);
          }
        })
        .catch(error => {
          this.$store.commit("SET_DELETEREPORT_FAILURE", {
            pending: false,
            statusCode: error.status
          });
          this.$notify({
            group: "foo",
            type: "error",
            title: "ERROR",
            text: error.response.data.message
          });
          this.$store.commit("setIsLoadingState", false);
        });
    },
    async createPostals(data, operation) {
      try {
        // Upload Report Postal
        await this.uploadImage({
          folio: data.folio,
          element: "#postal",
          description: "postal-asesoria",
          name: "postal-asesoria"
        });

        // Get URL from images uploaded to S3
        const victimsImagesURL = await Promise.all(
          this.record.victims.map(v => fetch(v.photo.replace(/\?.*$/, "")))
        );

        const victimsBlobs = await Promise.all(
          victimsImagesURL.map(imgURL => {
            console.log(imgURL);
            let file = new File([imgURL.blob()], "test.jpg");
            return this.getBase64(file);
          })
        );

        // Upload Victims Postals
        let victims = data.result.victims;
        if (operation === "updateReport") {
          victims = data.result.value.victims;
        }
        const victimsPostals = await Promise.all(
          victimsBlobs.map((blob, index) => {
            let victimInfo = {
              folio: data.folio,
              element: `#victim${victims[index].victimFolio}`,
              description: "postal-victima",
              name: victims[index].victimFolio,
              url: blob
            };
            return this.uploadImage(victimInfo);
          })
        );

        console.log(victimsPostals);

        this.$store.commit("SET_UPDATEREPORT_SUCCESS", {
          pending: false,
          statusCode: data.status,
          data: data
        });

        this.$notify({
          group: "foo",
          type: "success",
          title: "ÉXITO",
          text: data.message
        });
      } catch (error) {
        this.$store.commit("SET_UPDATEREPORT_FAILURE", {
          pending: false,
          statusCode: error.status
        });
        this.$notify({
          group: "foo",
          type: "error",
          title: "ERROR",
          text: error.response.data.message
        });
      }
    },
    uploadImage({ folio, element, description, name, url }) {
      return new Promise((resolve, reject) => {
        let imagePos = this.getImagePosition(document.querySelector(element));
        console.log(imagePos.y - document.querySelector(element).offsetTop);
        html2canvas(document.querySelector(element), {
          allowTaint: true,
          useCORS: true,
          backgroundColor: "white",
          scrollY: imagePos.y - document.querySelector(element).offsetTop,
          scale: 1
        }).then(canvas => {
          let imageData = {
            folio: folio,
            file: canvas.toDataURL("image/jpeg"),
            descrip: description,
            fileName: name
          };

          if (description === "postal-victima") {
            var ctx = canvas.getContext("2d");
            var victimImg = new Image();

            victimImg.src = url;

            victimImg.onload = () => {
              setTimeout(() => {
                let imageWidthScale = canvas.width / 3 / victimImg.naturalWidth;
                let imageHeightScale =
                  canvas.height / 2 / victimImg.naturalHeight;
                let imageMinScale =
                  imageWidthScale > imageHeightScale
                    ? imageHeightScale
                    : imageWidthScale;

                ctx.drawImage(
                  victimImg,
                  canvas.width / 8,
                  canvas.height / 4,
                  victimImg.naturalWidth * imageMinScale,
                  victimImg.naturalHeight * imageMinScale
                );
                imageData.file = canvas.toDataURL("image/jpeg");

                this.$store
                  .dispatch("uploadImage", imageData)
                  .then(response => {
                    this.$store.commit("SET_UPLOADIMAGE_SUCCESS", {
                      pending: false,
                      statusCode: response.status
                    });
                    return resolve(response.data);
                  })
                  .catch(error => {
                    this.$store.commit("SET_UPLOADIMAGE_FAILURE", {
                      pending: false,
                      statusCode: error.status
                    });
                    return reject("error");
                  });
              }, 500);
            };
          }

          this.$store
            .dispatch("uploadImage", imageData)
            .then(response => {
              this.$store.commit("SET_UPLOADIMAGE_SUCCESS", {
                pending: false,
                statusCode: response.status
              });
              return resolve(response.data);
            })
            .catch(error => {
              this.$store.commit("SET_UPLOADIMAGE_FAILURE", {
                pending: false,
                statusCode: error.status
              });
              return reject("error");
            });
        });
      });
    },
    getImagePosition(element) {
      const currentTop = window.pageXOffset;
      const currentLeft = window.pageYOffset;

      if (element) {
        if (element.getBoundingClientRect) {
          const { top, left } = element.getBoundingClientRect();
          return { x: left + currentLeft, y: top + currentTop };
        } else {
          // polyfill
          let xPosition = 0;
          let yPosition = 0;

          while (element) {
            xPosition +=
              element.offsetLeft - element.scrollLeft + element.clientLeft;
            yPosition +=
              element.offsetTop - element.scrollTop + element.clientTop;
            element = element.offsetParent;
          }
          return { x: xPosition, y: yPosition };
        }
      }
      return {
        x: 0,
        y: 0
      };
    },
    updateCsv() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("updateCsv")
          .then(response => {
            this.$store.commit("SET_UPDATECSV_SUCCESS", {
              pending: false,
              statusCode: response.status
            });
            return resolve("ok");
          })
          .catch(error => {
            this.$store.commit("SET_UPDATECSV_FAILURE", {
              pending: false,
              statusCode: error.status
            });
            return reject("error");
          });
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    addVictim() {
      this.$store.commit("updateVictims", {
        operation: "add",
        currentFolio: this.victims.length,
        caseFolio: this.record.folio
      });
    },
    openDialog() {
      this.dialog = true;
    }
  }
};
</script>

<style scoped lang="scss">
.all {
  max-width: 1900px;
}
p.headline {
  color: #be3117;
  font-size: 30px !important;
  font-weight: 600;
}
.postal {
  min-width: 570px;
}
.postal-form {
  padding: 0px;
}
.add-victim {
  align-items: center;
}
.btn--outline {
  width: 26px;
  height: 26px;
}
.btn-h {
  display: flex;
  align-items: center;
}
.end {
  justify-content: flex-end;
  padding-right: 15px;
}
.icon {
  font-size: 20px;
  margin-bottom: 1px;
}
</style>
